import { lazy } from 'react'

/**
 * Lazy-loads the element from `path`.
 *
 * @param {string} path the path to the element to load
 * @returns {React.LazyExoticComponent<React.ComponentType<any>>}
 */
export default path => lazy(() => import(`@ui/${path}`))
